import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=0fa29472&"
import script from "./inquire.vue?vue&type=script&lang=js&"
export * from "./inquire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports